// Types and functions used only in the all products modal variants.
import { BulkDownloadTrigger } from './bulk_download_helper';
import routes from 'sitewide-js/core_pre_webpack/routes';

export enum ModalVariant {
  BulkDownload = 'bulk_download',
  AllProducts = 'all_readers_products',
  NewUserDiscount = 'new_user_discount',
}

export enum NoThanksText {
  WantFree = 'No thanks, I want to stay on the Free tier',
  ThisPaper = 'No thanks, I just want this paper',
}

// when you have a more complicated work type, but only need the id
export type WorkWithId = {
  id: number;
};

// Redirect to the checkout page from the all products modal
export function navigateToCheckout(
  work: WorkWithId,
  variant: ModalVariant,
  trigger: BulkDownloadTrigger,
  extraParams?: { [key: string]: string },
) {
  window.location.href = checkoutUrl(work, variant, trigger, extraParams);
}

export function checkoutUrl(
  work: WorkWithId,
  variant: ModalVariant,
  trigger: BulkDownloadTrigger,
  extraParams?: { [key: string]: string },
) {
  const redirectUrlParams: any = { id: work.id };
  if (variant === ModalVariant.BulkDownload) {
    // Start the bulk download automatically after the user upgrades
    redirectUrlParams.bulkDownload = true;
  }

  const checkoutParams: any = {
    ...extraParams,
    feature: checkoutFeature(variant),
    trigger: trigger,
    upgradeRedirect: encodeURIComponent(
      routes.show_work_url(redirectUrlParams),
    ),
  };

  if (variant === ModalVariant.AllProducts) {
    // When the feature is set to "ALL_READER_PRODUCTS", we want to know which reader
    // products were shown to the user in case we expand the set of reader products
    // in the future. Here, we indicate that we showed the user the bulk download and
    // key takeaways products by using their abbreviations.
    checkoutParams.bd = true;
    checkoutParams.kt = true;
  }

  return routes.checkout_url(checkoutParams);
}

export function checkoutFeature(variant: ModalVariant): string {
  switch (variant) {
    case ModalVariant.BulkDownload:
      return 'BULK_DOWNLOAD';

    case ModalVariant.AllProducts:
      return 'ALL_READER_PRODUCTS';

    case ModalVariant.NewUserDiscount:
      return 'new_user_discount';

    default:
      return 'INVALID_ALL_PRODUCTS';
  }
}
